/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dormant_HintInputs */



/**
* | output |
* | --- |
* | "This integration isn't enabled in this environment yet." |
*
* @param {Integrations_Dormant_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dormant_hint = /** @type {((inputs?: Integrations_Dormant_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dormant_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Integration ist in dieser Umgebung noch nicht aktiviert.")
	return /** @type {LocalizedString} */ ("This integration isn't enabled in this environment yet.")
});